import React, { Component, Fragment } from 'react';
import { Box, TableContainer, Table, TableBody, TableRow, TableCell, TableHead, TableFooter, IconButton } from '@mui/material';
import Dialog from '../../common/Dialog';
import { MONTHS } from '../../../utils/generalFuncs';
import FacturePreview from '../Society/FacturePreview';
import { DownloadRounded } from '@mui/icons-material';
 // }
 import downloadjs from 'downloadjs';
 import html2canvas from 'html2canvas';
 
class SalaryDetails extends Component {
    state = {  }
    // onImageDownload = async () => {
    //     const canvas = await html2canvas(document.getElementById("section-to-print"));
    //     const dataURL = canvas.toDataURL('image/png');
    //     downloadjs(dataURL, `${this.props.salary.salary_employee}.png`, 'image/png');
    // };
    render() {
        const { 
            salary_employee,
            salary_base,
            salary_brut,
            salary_net,
            salary_to_pay,
            salary_lines_brut, 
            salary_lines_net,
            salary_lines_to_pay,
            salary_period_start,
            salary_period_end,
        } = this.props.salary;
        const { EMPLOYEES, SALARY_CATS, SERVICES, FUNCTIONS, currentEmployee } = this.props;
        let employee = EMPLOYEES ? EMPLOYEES[salary_employee] : currentEmployee
        return (
            <Dialog
                maxWidth="lg"
                open={true}
                close={this.props.handleClose}
                title="Aperçu"
                submitAction={this.props.handleSubmit}
                // secondaryAction={
                //     <IconButton
                //         aria-label="download"
                //         // className={classes.closeButton}
                //         // onClick={() => console.log("HELLOOOOOO")}
                //         onClick={this.onImageDownload}
                //         size="large"
                //     >
                //         <DownloadRounded />
                //     </IconButton>
                // }
            >
                {/* <FacturePreview
                    title={`${employee.employee_lastname}_${String(new Date(salary_period_end).getMonth() + 1).padStart(2, '0')}${new Date(salary_period_end).getFullYear()}`}
                > */}

                    <TableContainer>
                        <Table className="salaryTable, table">
                            <TableBody>
                                <TableRow className="title">
                                    <TableCell colSpan={4}>BULLETIN DE PAIE</TableCell>
                                    <TableCell colSpan={4}>{MONTHS[new Date(salary_period_end).getMonth()]} {new Date(salary_period_end).getFullYear()}</TableCell>
                                </TableRow>
                                <TableRow className="noBorder">
                                    <TableCell colSpan={2} component="th">Matricule</TableCell>
                                    <TableCell colSpan={2}>: {employee.employee_matricule}</TableCell>
                                    <TableCell colSpan={2} component="th">Catégorie</TableCell>
                                    <TableCell colSpan={2}>:</TableCell>
                                </TableRow>
                                <TableRow className="noBorder">
                                    <TableCell colSpan={2} component="th">Nom et Prénom(s)</TableCell>
                                    <TableCell colSpan={2}>: {employee.employee_lastname} {employee.employee_firstname}</TableCell>
                                    <TableCell colSpan={2} component="th">Salaire de Base</TableCell>
                                    <TableCell colSpan={2}>: {salary_base.toLocaleString("fr-FR")}</TableCell>
                                </TableRow>
                                <TableRow className="noBorder">
                                    <TableCell colSpan={2} component="th">Date d'Embauche</TableCell>
                                    <TableCell colSpan={2}>: {new Date(employee.employee_hire_date).toLocaleDateString("fr-FR")}</TableCell>
                                    <TableCell colSpan={2} component="th">N° CNSS</TableCell>
                                    <TableCell colSpan={2}>: {employee.employee_cnss}</TableCell>
                                </TableRow>
                                <TableRow className="noBorder">
                                    <TableCell colSpan={2} component="th">Situation Matr</TableCell>
                                    <TableCell colSpan={2}>: {employee.employee_sit_matr}</TableCell>
                                    <TableCell colSpan={2} component="th">Mode de Réglement</TableCell>
                                    <TableCell colSpan={2}>:</TableCell>
                                </TableRow>
                                <TableRow className="noBorder">
                                    <TableCell colSpan={2} component="th">Service</TableCell>
                                    <TableCell colSpan={2}>: {SERVICES && SERVICES[employee.employee_service].service_name}</TableCell>
                                    <TableCell colSpan={2} component="th">N° Compte</TableCell>
                                    <TableCell colSpan={2}>: </TableCell>
                                </TableRow>
                                <TableRow className="noBorder">
                                    <TableCell colSpan={2} component="th">Fonction</TableCell>
                                    <TableCell colSpan={2}>: {FUNCTIONS && FUNCTIONS[employee.employee_function].function_name}</TableCell>
                                    <TableCell colSpan={2} component="th">Banque</TableCell>
                                    <TableCell colSpan={2}>:</TableCell>
                                </TableRow>
                                <TableRow className="title">
                                    <TableCell colSpan={3}>Rubrique</TableCell>
                                    <TableCell>Base</TableCell>
                                    <TableCell>Qté ou Taux</TableCell>
                                    <TableCell>Retenue</TableCell>
                                    <TableCell>Gain</TableCell>
                                    <TableCell>Part Employeur</TableCell>
                                </TableRow>
                                <TableRow className="total">
                                    <TableCell colSpan={3}>Salaire de Base</TableCell>
                                    <TableCell align="right">{salary_base.toLocaleString("fr-FR")}</TableCell>
                                    <TableCell align="center">1</TableCell>
                                    <TableCell></TableCell>
                                    <TableCell align="right">{salary_base.toLocaleString("fr-FR")}</TableCell>
                                    <TableCell></TableCell>
                                </TableRow>
                                {salary_lines_brut && salary_lines_brut.map( line => (
                                    <TableRow key={line.salary_line_id}>
                                        <TableCell colSpan={3}>{SALARY_CATS[line.salary_line_name].salary_cat_name}</TableCell>
                                        <TableCell align="right">{line.salary_line_base ? line.salary_line_base.toLocaleString("fr-FR") : ""}</TableCell>
                                        <TableCell align="right">{line.salary_line_rate ? line.salary_line_rate.toLocaleString("fr-FR") : ""}</TableCell>
                                        <TableCell align="right">{line.salary_line_retenue ? line.salary_line_retenue.toLocaleString("fr-FR") : ""}</TableCell>
                                        <TableCell align="right">{line.salary_line_gain ? line.salary_line_gain.toLocaleString("fr-FR") : ""}</TableCell>
                                        <TableCell align="right">{line.salary_line_employer ? line.salary_line_employer.toLocaleString("fr-FR") : ""}</TableCell>
                                    </TableRow>
                                ))}

                                <TableRow className="total">
                                    <TableCell colSpan={3}>SALAIRE BRUT</TableCell>
                                    <TableCell></TableCell>
                                    <TableCell></TableCell>
                                    <TableCell></TableCell>
                                    <TableCell align="right">{salary_brut && salary_brut.toLocaleString("fr-FR")}</TableCell>
                                    <TableCell></TableCell>
                                </TableRow>
                                {salary_lines_net && salary_lines_net.map( line => (
                                    <TableRow key={line.salary_line_id}>
                                        <TableCell colSpan={3}>{SALARY_CATS[line.salary_line_name].salary_cat_name}</TableCell>
                                        <TableCell align="right">{line.salary_line_base ? line.salary_line_base.toLocaleString("fr-FR") : ""}</TableCell>
                                        <TableCell align="right">{line.salary_line_rate ? line.salary_line_rate.toLocaleString("fr-FR") : ""}</TableCell>
                                        <TableCell align="right">{line.salary_line_retenue ? line.salary_line_retenue.toLocaleString("fr-FR") : ""}</TableCell>
                                        <TableCell align="right">{line.salary_line_gain ? line.salary_line_gain.toLocaleString("fr-FR") : ""}</TableCell>
                                        <TableCell align="right">{line.salary_line_employer ? line.salary_line_employer.toLocaleString("fr-FR") : ""}</TableCell>
                                    </TableRow>
                                ))}
                                <TableRow className="total">
                                    <TableCell colSpan={3}>SALAIRE NET</TableCell>
                                    <TableCell></TableCell>
                                    <TableCell></TableCell>
                                    <TableCell></TableCell>
                                    <TableCell align="right">{salary_net && salary_net.toLocaleString("fr-FR")}</TableCell>
                                    <TableCell></TableCell>
                                </TableRow>
                                {salary_lines_to_pay && salary_lines_to_pay.map( line => (
                                    <TableRow key={line.salary_line_id}>
                                        <TableCell colSpan={3}>{SALARY_CATS[line.salary_line_name].salary_cat_name}</TableCell>
                                        <TableCell align="right">{line.salary_line_base ? line.salary_line_base.toLocaleString("fr-FR") : ""}</TableCell>
                                        <TableCell align="right">{line.salary_line_rate ? line.salary_line_rate.toLocaleString("fr-FR") : ""}</TableCell>
                                        <TableCell align="right">{line.salary_line_retenue ? line.salary_line_retenue.toLocaleString("fr-FR") : ""}</TableCell>
                                        <TableCell align="right">{line.salary_line_gain ? line.salary_line_gain.toLocaleString("fr-FR") : ""}</TableCell>
                                        <TableCell align="right">{line.salary_line_employer ? line.salary_line_employer.toLocaleString("fr-FR") : ""}</TableCell>
                                    </TableRow>
                                ))}
                                <TableRow className="total">
                                    <TableCell colSpan={5}>MONTANT À PAYER</TableCell>
                                    <TableCell></TableCell>
                                    <TableCell align="right">{salary_to_pay && salary_to_pay.toLocaleString("fr-FR")}</TableCell>
                                    <TableCell></TableCell>
                                </TableRow>
                            </TableBody>
                        </Table>
                    </TableContainer>
                {/* </FacturePreview> */}
            </Dialog>
        );
    }
}

export default SalaryDetails;